import React from "react";
import { usePopper } from "react-popper";
import { Portal } from "semantic-ui-react";

export type RightClickMenuItem = RightClickMenuItemItem | RightClickMenuSeparator;
export interface RightClickMenuItemItem {
  type: "item";
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  renderConfirm?: (onClose: () => void) => JSX.Element;
}

interface RightClickMenuSeparator {
  type: "separator";
}

interface Props {
  target: HTMLElement;
  menuItems: RightClickMenuItem[];
  setConfirmingItem: (item: RightClickMenuItemItem) => void;
}

export const RightClickMenuPopper = (props: Props) => {
  const [popperElement, setPopperElement] = React.useState<HTMLElement>(null);

  const { styles, attributes } = usePopper(props.target, popperElement, {
    modifiers: [
      { name: "preventOverflow", options: { mainAxis: true, altAxis: true } },
    ]
  });

  const onClick = (item: RightClickMenuItemItem) => {
    if (!item.renderConfirm) {
      item.onClick();
      return;
    }

    props.setConfirmingItem(item);
  }

  return <>
    <Portal open={true}>
      <div
        className="right-click-menu-popup-wrapper"
        ref={setPopperElement}
        style={{
          right: "auto",
          left: "auto",
          position: "initial",
          ...styles.popper
        }}
        {...attributes.popper}
      >
        {props.menuItems.map((item, index) => <React.Fragment key={item.type === "item" ? item.label : `separator-${index}`}>
          {item.type === "item" ? (
            <div className="right-click-menu-item-row" onClick={() => onClick(item)}>
              <div>{item.label}</div>
              {item.icon && <div style={{ height: 18 }}>{item.icon}</div>}
            </div>
          ) : (
            <div className="right-click-menu-separator" />
          )}
        </React.Fragment>)}
      </div>
    </Portal>
  </>
}

interface RightClickMenuConfirmProps {
  confirmingItem: RightClickMenuItemItem;
  closeConfirmingItem: () => void;
}

export const RightClickMenuConfirm = (props: RightClickMenuConfirmProps) => {
  if (!props.confirmingItem) {
    return null;
  }

  return props.confirmingItem.renderConfirm ? props.confirmingItem.renderConfirm(props.closeConfirmingItem) : null;
}